import { Nullable } from 'legacy/lut/classes/models/utils'
import { FC, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { useGetFormDataField } from 'cng-common/features/form'
import { selectPublishingMode } from 'core/store/selectors/selectPublishingMode'
import { FieldLabel } from 'partner360/components/fieldLabel/FieldLabel'

import { PARTNER_BASIC_INFO_FORM_KEY, partnerBasicInfoFields } from '../../../configs'
import { ApplicableToggle } from '../../applicableToggle/ApplicableToggle'

import { BranchesEditMode } from './components/branchesEditMode/BranchesEditMode'
import { BranchesReadMode } from './components/branchesReadMode/BranchesReadMode'
import { getBranchesFieldLabelTranslation } from './helpers/getBranchesFieldLabelTranslation'

import styles from './Branches.module.scss'

interface IBranchesProps {
  isRetail?: boolean
  isDistributor?: boolean
  isGlobalPartner?: boolean

  isApplicable: boolean
  count: Nullable<number>
  locations: string
}

export const Branches: FC<IBranchesProps> = ({
  isRetail,
  isDistributor,
  isApplicable: initialApplicableValue,
  count,
  locations,
}) => {
  const isEditMode = useSelector(selectPublishingMode)

  const applicableField = useGetFormDataField<boolean>(
    PARTNER_BASIC_INFO_FORM_KEY,
    partnerBasicInfoFields.branchesIsApplicable
  )

  const isApplicableValue = useMemo(
    () => (isEditMode ? applicableField[0] : initialApplicableValue),
    [isEditMode, applicableField, initialApplicableValue]
  )

  const isHideApplicableLabel = useMemo(() => !!isRetail, [isRetail])

  const branchesFieldLabel = useMemo(() => {
    return getBranchesFieldLabelTranslation({
      isRetail,
      isDistributor,
    })
  }, [isRetail, isDistributor])

  return (
    <div className={styles.root}>
      <div className={styles.row}>
        <div className={styles.labelWrapper}>
          <span className={styles.sectionIcon} aria-hidden="true">
            <i className="kbase kbase-home" />
          </span>
          <FieldLabel labelTranslation={branchesFieldLabel} />
        </div>
        {isEditMode && (
          <ApplicableToggle
            containerClassName={styles.applicableWrapper}
            isEditMode={isEditMode}
            formKey={PARTNER_BASIC_INFO_FORM_KEY}
            defaultValue={initialApplicableValue}
            field={partnerBasicInfoFields.branchesIsApplicable}
            isHideLabel={isHideApplicableLabel}
          />
        )}
      </div>
      {!isEditMode && (
        <BranchesReadMode
          isApplicable={initialApplicableValue}
          count={count}
          locations={locations}
          isCountEnabled={!isRetail}
        />
      )}
      {isEditMode && (
        <BranchesEditMode
          isApplicable={isApplicableValue}
          count={count}
          locations={locations}
          isCountEnabled={!isRetail}
        />
      )}
    </div>
  )
}
